import { useDeviceType } from '@cian/ui-kit/responsive';
import * as React from 'react';

import { CookieAgreementBar } from '../../components/CookieAgreementBar';
import { CookieAgreementModal } from '../../components/CookieAgreementModal';
import { setCookie } from '../../../client/utils/cookie';
import { COOKIE_AGREEMENT_ACCEPTED_KEY } from '../../constants';

interface ICookieAgreementContainer {
  isAdaptive: boolean;
}

export const CookieAgreementContainer: React.FC<ICookieAgreementContainer> = ({ isAdaptive }) => {
  const deviceType = useDeviceType();
  const [isModalOpen, setModalOpen] = React.useState<boolean>(false);
  const [isCookieAccepted, setCookieAccepted] = React.useState<boolean>(false);

  const normalizedDeviceType = isAdaptive ? deviceType : 'desktop';
  const isBarVisible = normalizedDeviceType === 'desktop' ? !isModalOpen : true;

  const handleModalClose = React.useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);

  const handleViewAgreement = React.useCallback(
    (event: React.SyntheticEvent<HTMLAnchorElement>) => {
      event.preventDefault();
      setModalOpen(true);
    },
    [setModalOpen],
  );

  const handleAccept = React.useCallback(() => {
    setCookie(COOKIE_AGREEMENT_ACCEPTED_KEY, 'true', 356);

    setModalOpen(false);
    setCookieAccepted(true);
  }, []);

  if (isCookieAccepted) {
    return null;
  }

  return (
    <>
      {isBarVisible && (
        <CookieAgreementBar
          deviceType={normalizedDeviceType}
          onViewAgreement={handleViewAgreement}
          onAccept={handleAccept}
        />
      )}
      <CookieAgreementModal
        deviceType={deviceType}
        isOpen={isModalOpen}
        onClose={handleModalClose}
        onAccept={handleAccept}
      />
    </>
  );
};

CookieAgreementContainer.displayName = 'CookieAgreementContainer';
